import { Injectable } from '@angular/core';
import { RouterSerializer } from '@interacta-shared/data-access-common';
import { GenericAppRouterState } from '@interacta-shared/util-common';
import {
    AppBaseRoute,
    AppRoute,
    toBaseRoute,
    urlToAppRoute,
} from '@modules/app-routing/routes';

export type AppRouterState = GenericAppRouterState<AppRoute, AppBaseRoute>;

@Injectable({ providedIn: 'root' })
export class AppRouterSerializer extends RouterSerializer<
    AppRoute,
    AppBaseRoute,
    AppRouterState
> {
    protected urlToAppRoute(url: string): AppRoute | null {
        return urlToAppRoute(url);
    }

    protected toBaseRoute(appRoute: AppRoute | null): AppBaseRoute | null {
        return toBaseRoute(appRoute);
    }
}
